import { categories } from '../../../mocks/categories';
import CategoryCard from './CategoryCard';

export default function CategoryGrid() {
  return (
    <section id="kategoriler" className="bg-[#0a0a0f] py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-purple-500/10 border border-purple-500/20 rounded-full px-4 py-1.5 mb-5">
            <i className="ri-apps-2-line text-purple-400 text-sm" />
            <span className="text-purple-300 text-xs font-medium tracking-wide uppercase">
              Tüm Kategoriler
            </span>
          </div>
          <h2
            className="text-3xl md:text-5xl font-bold text-white mb-4"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            İlgilendiğin Alanı{' '}
            <span
              className="bg-clip-text text-transparent"
              style={{ backgroundImage: 'linear-gradient(135deg, #a855f7, #ec4899)' }}
            >
              Seç
            </span>
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Bir kategoriye tıkla — WhatsApp üzerinden sana özel kampanyalar anında gelsin.
          </p>

          {/* FOMO bar */}
          <div
            className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 rounded-full text-sm"
            style={{
              background: 'rgba(239,68,68,0.08)',
              border: '1px solid rgba(239,68,68,0.25)',
              color: '#fca5a5',
            }}
          >
            <span className="w-1.5 h-1.5 rounded-full bg-red-400 animate-pulse" />
            ⚡ Son 24 saatte{' '}
            <strong className="text-red-300">1.247 kişi</strong> fırsat aldı. Kaçırma!
          </div>
        </div>

        {/* Category grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <CategoryCard key={cat.id} category={cat} />
          ))}
        </div>

        {/* Bottom hint */}
        <div className="text-center mt-10">
          <p className="text-gray-600 text-sm">
            💡 Birden fazla alan seçebilirsin — her biri için ayrı bildirim alırsın.
          </p>
        </div>
      </div>
    </section>
  );
}
